var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"document-item",attrs:{"to":/documents/ + _vm.item.id}},[_c('img',{staticClass:"document-item__img",attrs:{"src":require("@/assets/img/file-document.svg")}}),_c('div',{staticClass:"document-item__content"},[_c('div',{staticClass:"document-item__name"},[_vm._v(_vm._s(_vm.item.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }